import React, { useState, useEffect } from "react";
import { getTemplates, updateTemplates } from "./ducks/services";
import { Popup } from "../../atoms/Popup";
import { useSelector } from "react-redux";
import SectionHeader from "../../molecules/SectionHeader";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Loader } from "../../atoms/Loader";

import {
  Col,
  Row,
  Space,
  Table,
  Button,
  Typography,
  message,
  Switch,
} from "antd";

import { useForm } from "react-hook-form";
import { EditOutlined } from "@ant-design/icons";
import HtmlEditor from "./HtmlEditor";
import { getOrginationListService } from "../Reports/service";
import { formatString } from "../../../utils/formatString";
const { Title } = Typography;
var _ = require("lodash");
let modalContent = "ALL";

export default React.memo((props) => {
  const [selectedItem, setSelected] = useState(null);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(null);
  const [search, setSearch] = useState("");
  const [orgId, setOrgId] = useState(null);
  const [page, setPage] = useState(1);
  const [isLoading, setIsloading] = useState(false);
  const [html, setHtml] = useState("<h1>Hello, world!</h1>");
  const [searchingText, setSearchText] = useState(null);
  const [searchingBy, setSearchBy] = useState(null);
  const [templateData, setTemplateData]: any = useState({});
  const [organizationList, setOrginizationList] = useState(null);

  const getSearchData = (text) => {
    if (searchingBy) {
      setSearchText(text);
      setSearch(`${searchingBy}=${text}`);
    }
    setPage(1);
  };

  const orgList = async () => {
    try {
      const data = await getOrginationListService();
      data.push({
        orgId: null,
        name: "All Orgnizations",
      });
      data.reverse();
      setOrginizationList(data);
    } catch (errr) {
      console.log(errr);
    }
  };
  const {
    formState: { errors },
  } = useForm({});

  const getTemplateData = async () => {
    let query = {};

    if (searchingText && orgId) {
      query["templateName"] = searchingText;
      orgId?.value ? (query["orgId"] = orgId?.value) : null;
    } else if (searchingText) {
      query["templateName"] = searchingText;
    } else if (orgId) {
      orgId?.value ? (query["orgId"] = orgId?.value) : null;
    }

    try {
      setIsloading(true);
      let result = await getTemplates(10, page, query);
      setTemplateData(result);
      if (result) {
        setIsloading(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getTemplateData();
  }, [page, search, orgId]);

  useEffect(() => {
    orgList();
  }, []);

  const onEdit = (record) => {
    setHtml(record?.htmlTemplate);
    modalContent = "USER";
    setVisible(true);
    setTrigger(1);
    setSelected(record);
  };

  const onTopSearch = (e) => {
    setSearch(e.target.value);
  };

  const setOrgIdData = (e) => {
    setOrgId(e);
    setPage(1);
  };
  const UpdatetemplateStatus = (record) => {
    setHtml(record?.htmlTemplate);
    const clone = _.cloneDeep(record);

    try {
      clone.status = clone.status == "enable" ? "disable" : "enable";
      updateTemplatData(clone, 2);
    } catch (error) {
      console.log(error, "error");
    }
  };
  const updateTemplatData = async (selectedRecord, type = null) => {
    try {
      let data = {
        htmlTemplate: type === 2 ? selectedRecord?.htmlTemplate : html,
        businessUnitId: type ? selectedRecord?.businessUnitId : "default",
        templateName: type ? selectedRecord?.templateName : "templateName",
        templateType: type ? selectedRecord?.templateType : "default",
        placeholders: type ? selectedRecord?.placeholders : [],
        status: type ? selectedRecord?.status : "enable",
      };

      type ? (data["templateId"] = selectedRecord?.templateId) : data;
      const result = await updateTemplates(data, type);
      if (result) {
        message.success("Template updated successfully");
        setVisible(false);
        setTrigger(null);
        getTemplateData();
        return result;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns: any = [
    {
      title: "Template Name",
      dataIndex: "templateName",
      // key: "templateName",
      field: "templateName",
      width: 200,
      render: (text) => (text ? formatString(text) : "-"),
    },
    {
      title: "Organization",
      dataIndex: "orgName",
      key: "orgName",
      width: 200,
      render: (text) => (text ? formatString(text) : "-"),
    },
    {
      title: "Template Status",
      dataIndex: "status",
      key: "status",
      width: 200,
      render: (text) => (text ? formatString(text) : "-"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      width: 200,
      render: (text, record) => {
        return (
          <Space size={16} className="ag-actions">
            {/* Edit button */}
            <Button
              type="link"
              className="p-0 ag-success"
              onClick={() => onEdit(record)}
            >
              <div className="Simple-tooltip">
                <EditOutlined />
                <section className="tt-content">Edit</section>
              </div>
            </Button>

            {/* Enable disable switch */}
            <div className="Simple-tooltip">
              <Switch
                className="switch"
                onChange={() => UpdatetemplateStatus(record)}
                defaultChecked={record?.status === "enable" ? true : false}
              />
              <section className="tt-content">{record.status}</section>
            </div>
          </Space>
        );
      },
    },
  ];

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          Add Template
        </Title>
      ),
      content: (
        <HtmlEditor
          trigger={trigger}
          updateTemplatData={updateTemplatData}
          selectedRecord={selectedItem}
          html={html}
          setHtml={setHtml}
        />
      ),
      width: "90%",
    },
    {
      title: (
        <Title level={3} className="m-0">
          Edit Template
        </Title>
      ),
      content: (
        <HtmlEditor
          updateTemplatData={updateTemplatData}
          trigger={trigger}
          selectedRecord={selectedItem}
          html={trigger == 0 ? "<h1>Hello, world!</h1>" : html}
          setHtml={setHtml}
        />
      ),
      width: "90%",
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger]?.title,
    width: popup[trigger]?.width,
    content: popup[trigger]?.content,
    onCancel: () => {
      modalContent = "ALL";
      setSelected(undefined);
      setVisible(false);
    },
  };

  let initialSearchKeys = [
    // { value: "orgName", label: "Organization Name" },
    { value: "templateName", label: "Template Name" },
  ];

  return (
    <>
      <DashboardLayout>
        <SectionHeader
          search={onTopSearch}
          heading="Templates"
          setOrgId={setOrgIdData}
          // addNewAction={addNew}
          total={templateData?.totalCount}
          setSearchBy={setSearchBy}
          searchingBy={searchingBy}
          setSearchText={getSearchData}
          searchingText={searchingText}
          searchOptions={initialSearchKeys}
          organizationList={organizationList}
          requiredOrgOptions={true}
        />
        <Row gutter={24}>
          <Col span={24}>
            {isLoading ? (
              <Loader height={60}></Loader>
            ) : (
              <Table
                columns={columns}
                rowKey={(record, index) => index}
                className="custom-table org_table_wrap organizations"
                pagination={{
                  current: page,
                  position: ["topLeft"],
                  showSizeChanger: false,
                  pageSize: templateData?.perPage ?? 10,
                  className: "ag-property-text-pagination mb-1",
                  onChange: (e) => {
                    setPage(e);
                    if (searchingText && searchingBy) {
                      setSearch(`${searchingBy}=${searchingText}`);
                    }
                  },
                  total: templateData?.totalCount,
                  showTotal: (total, range) =>
                    `Showing ${range[0]}-${range[1]} of ${total} Organizations`,
                }}
                dataSource={templateData?.data}
                scroll={{ y: 500 }}
              />
            )}
          </Col>
        </Row>
      </DashboardLayout>
      <Popup {...popupProps} />
    </>
  );
});
